// File: src/blocks/cav/tabbed-content/view.js
(function () {
  function $all(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function activateByButton(root, btn, focus = true) {
    const id = btn.getAttribute("aria-controls");
    if (!id) return;

    const items = $all(root, ".cav-tabbed-content__list--item");
    const buttons = $all(root, '.cav-tabbed-content__header [role="tab"]');
    const panels = $all(root, `#${CSS.escape(id)}`).length
      ? $all(root, `.cav-tabbed-content__items > #${CSS.escape(id)}`)
      : $all(root, ".cav-tabbed-content__items > *");

    // Deactivate all
    items.forEach((li) => li.classList.remove("is-active"));
    buttons.forEach((b) => {
      b.setAttribute("aria-selected", "false");
      b.setAttribute("tabindex", "-1");
    });

    // Hide all panels
    $all(root, ".cav-tabbed-content__items > *").forEach((p) => {
      p.classList.remove("is-active");
      p.setAttribute("hidden", "");
      if (!p.hasAttribute("role")) p.setAttribute("role", "tabpanel");
    });

    // Activate clicked
    const li = btn.closest(".cav-tabbed-content__list--item");
    if (li) li.classList.add("is-active");
    btn.setAttribute("aria-selected", "true");
    btn.setAttribute("tabindex", "0");
    if (focus) btn.focus({ preventScroll: true });

    const panel = root.querySelector(`#${CSS.escape(id)}`);
    if (panel) {
      panel.classList.add("is-active");
      panel.removeAttribute("hidden");
      if (!panel.hasAttribute("role")) panel.setAttribute("role", "tabpanel");
      // Optional: update hash (comment out if undesired)
      // history.replaceState(null, "", `#${panel.+id}`);
    }
  }

  function initTabs(root) {
    if (root.__cavTabsReady) return;
    root.__cavTabsReady = true;

    const header = root.querySelector(".cav-tabbed-content__header");
    if (!header) return;

    // Ensure the tablist has role
    if (!header.hasAttribute("role")) header.setAttribute("role", "tablist");

    const buttons = $all(root, ".cav-tabbed-content__header button");
    if (!buttons.length) return;

    // Normalize ARIA on buttons
    buttons.forEach((btn, i) => {
      btn.setAttribute("role", "tab");
      if (!btn.hasAttribute("aria-controls")) {
        // Try to infer panel id from button id
        const base = (btn.id || "").replace(/^tabBtn_/, "");
        if (base) btn.setAttribute("aria-controls", `tabPanel_${base}`);
      }
      // Manage roving tabindex: only the selected gets 0, others -1
      const selected = btn.getAttribute("aria-selected") === "true";
      btn.setAttribute("tabindex", selected ? "0" : "-1");

      // Click
      btn.addEventListener("click", () => activateByButton(root, btn, true));

      // Keyboard
      btn.addEventListener("keydown", (e) => {
        const idx = buttons.indexOf(btn);
        let target = null;
        switch (e.key) {
          case "ArrowRight":
          case "Right":
            target = buttons[(idx + 1) % buttons.length];
            break;
          case "ArrowLeft":
          case "Left":
            target = buttons[(idx - 1 + buttons.length) % buttons.length];
            break;
          case "Home":
            target = buttons[0];
            break;
          case "End":
            target = buttons[buttons.length - 1];
            break;
          case "Enter":
          case " ":
          case "Spacebar":
            activateByButton(root, btn, true);
            e.preventDefault();
            return;
        }
        if (target) {
          target.focus();
          activateByButton(root, target, false);
          e.preventDefault();
        }
      });
    });

    // Panels: hide non-active on load, ensure role
    $all(root, ".cav-tabbed-content__items > *").forEach((p) => {
      if (!p.hasAttribute("role")) p.setAttribute("role", "tabpanel");
      const isActive = p.classList.contains("is-active");
      if (!isActive) p.setAttribute("hidden", "");
      else p.removeAttribute("hidden");
    });

    // Initial activation: hash or current aria-selected, else first
    (function initial() {
      const hash = decodeURIComponent(location.hash || "").replace(/^#/, "");
      if (hash) {
        // Accept raw tabId, tabPanel_* or tabBtn_*
        const normalized = hash.startsWith("tabPanel_")
          ? hash
          : hash.startsWith("tabBtn_")
          ? hash.replace(/^tabBtn_/, "tabPanel_")
          : `tabPanel_${hash}`;
        const btn = root.querySelector(`[aria-controls="${normalized}"]`);
        if (btn) {
          activateByButton(root, btn, false);
          return;
        }
      }
      const selected =
        buttons.find((b) => b.getAttribute("aria-selected") === "true") ||
        buttons[0];
      if (selected) activateByButton(root, selected, false);
    })();
  }

  function initAll() {
    document
      .querySelectorAll(".cav-tabbed-content__header")
      .forEach((header) => {
        const root = header.closest("section, .wp-block-cav-tabbed-content");
        if (root) initTabs(root);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // If your page updates via AJAX (e.g., Search & Filter Pro), keep tabs working
  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
